import { ConfiguracaoDeTexto, ParametrosGerais, TextoModel } from "../models/textoModel"

export const ParametrosGeraisInicial: ParametrosGerais = {
    negrito: false,
    qtdVias: 1,
    colunas: 48,
    qtdLinhasPosImpressao: 0,
    fonte: 0,
    textoInicioLinha: "",
    exibirLogo: false,
    linhaAposProduto: false,
}

const ConfiguracaoDeTextoInicial: ConfiguracaoDeTexto = {
    ativo: true,
    margemSuperior: 0,
    margemInferior: 0,
    margemEsquerda: 0,
    fonte: 0,
    negrito: false,
    valorDireita: false,
}

export const TextoImpressaoInicial: TextoModel = {
    parametrosGerais: ParametrosGeraisInicial,
    idDoPedido: ConfiguracaoDeTextoInicial,
    data: ConfiguracaoDeTextoInicial,
    cliente: ConfiguracaoDeTextoInicial,
    cpf: ConfiguracaoDeTextoInicial,
    telefone: ConfiguracaoDeTextoInicial,
    previsaoEntrega: ConfiguracaoDeTextoInicial,
    rua: ConfiguracaoDeTextoInicial,
    numeroRua: ConfiguracaoDeTextoInicial,
    bairro: ConfiguracaoDeTextoInicial,
    cidade: ConfiguracaoDeTextoInicial,
    avisoCartela: ConfiguracaoDeTextoInicial,
    pedidosAnteriores: ConfiguracaoDeTextoInicial,

    categoria: ConfiguracaoDeTextoInicial,
    produto: ConfiguracaoDeTextoInicial,
    grupoDeOpcao: ConfiguracaoDeTextoInicial,
    opcao: ConfiguracaoDeTextoInicial,
    observacaoProduto: ConfiguracaoDeTextoInicial,
    observacaoPedido: ConfiguracaoDeTextoInicial,

    pagamento: ConfiguracaoDeTextoInicial,
    subtotal: ConfiguracaoDeTextoInicial,
    taxaDeEntrega: ConfiguracaoDeTextoInicial,
    desconto: ConfiguracaoDeTextoInicial,
    taxaAdicional: ConfiguracaoDeTextoInicial,
    trocoPara: ConfiguracaoDeTextoInicial,
    troco: ConfiguracaoDeTextoInicial,
    total: ConfiguracaoDeTextoInicial,

    cnpj: ConfiguracaoDeTextoInicial,
    nomeEstabelecimento: ConfiguracaoDeTextoInicial,
    numeroEstabelecimento: ConfiguracaoDeTextoInicial,
}
